import React, { useState } from 'react';

const defaultValue = {
  gruposCliente: [],
  grupoCliente: {},
  loading: false,
  totalElements: 0,
  search: '',
  page: 0,
  size: 15,
  sort: 'nome, asc',
  formulario: 'listagem',
};

export const GrupoClienteContext = React.createContext({});

export const GrupoClienteProvider = (props) => {
  return (
    <GrupoClienteContext.Provider
      value={{
        gruposCliente: useState(defaultValue.gruposCliente),
        grupoCliente: useState(defaultValue.grupoCliente),
        loading: useState(defaultValue.loading),
        formulario: useState(defaultValue.formulario),
        totalElements: useState(defaultValue.totalElements),
        search: useState(defaultValue.search),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        sort: useState(defaultValue.sort),
      }}
    >
      {props.children}
    </GrupoClienteContext.Provider>
  );
};

export const GrupoClienteConsumer = GrupoClienteContext.Consumer;
